import get from 'lodash/get';
import Browser from './Browser';

class Payload {
  static isInHand(serverPayload) {
    const ads = this.findAdsInPayload(serverPayload);
    const t = get(ads, '[0].tracking_pixels[0]', false);
    return t && Browser.isUrlInHandPixel(t);
  }

  static validate(payload) {
    const localPayload = payload;
    const actions = get(payload, 'data.actions', []);
    actions.forEach(element => {
      const localElement = element;
      const hasFields = localElement.type === 'fields' && get(localPayload, 'data.fields');
      if (localElement.type === 'queue_interstitial' && typeof localElement.ads !== 'undefined') {
        localElement.ads.forEach(ad => {
          // handle token replacement
          if (typeof ad.tracking_pixels !== 'undefined') {
            ad.tracking_pixels = ad.tracking_pixels.map(pixelElement =>
              pixelElement.replace(
                /%25%25CACHEBUSTER%25%25/g,
                Math.floor(Math.random() * (99999999 - 1)) + 1
              )
            );
          }
        });
      } else if (hasFields) {
        localPayload.data.fields = localElement.data;
      }
    });
    if (get(localPayload, 'fields.url_icon')) {
      localPayload.data.fields.url_icon = `https://s3.amazonaws.com/checkpointsmedia/400/xdpi/${localPayload.data.fields.url_icon}`;
    }

    return localPayload;
  }

  /**
   * Reformat the payload in the new format we expect from the server.
   * If ads.length > 1, then this formatting won't be necessary and should have no ill-effect.
   * @param serverPayload
   * @returns {*}
   */
  static reformat(serverPayload) {
    let queueInterstitial = this.findActionInPayload(serverPayload, 'queue_interstitial');
    // eslint-disable-next-line prefer-destructuring
    queueInterstitial = queueInterstitial[0];
    delete queueInterstitial.url;
    delete queueInterstitial.tracking_pixels;
    delete queueInterstitial.impression_id;
    delete queueInterstitial.html;
    // the tracking_pixel_html is universally a moat pixel template and fine to put on all ads.
    if (get(queueInterstitial, 'tracking_pixel_html', null) !== null) {
      get(queueInterstitial, 'ads', []).forEach(
        // eslint-disable-next-line no-return-assign,no-param-reassign
        ad => (ad.tracking_pixel_html = queueInterstitial.tracking_pixel_html)
      );
      delete queueInterstitial.tracking_pixel_html;
    }
    if (get(queueInterstitial, 'fetchJson', null) !== null) {
      get(queueInterstitial, 'ads[0]').fetchJson = queueInterstitial.fetchJson;
      delete queueInterstitial.fetchJson;
    }
    return serverPayload;
  }

  static findAction(actionsArray, actionName, defaultValue = [{}], expected = null) {
    const ret = actionsArray.filter(action => action.type === actionName);
    if (expected !== null && ret.length !== expected) {
      throw new Error(`Was expecting ${expected} ${actionName}, but got ${ret.length} instead!`);
    }
    return ret.length > 0 ? ret : defaultValue;
  }

  static findAdProperties(actionsArray, propertyName) {
    const queueInterstitial = this.findAction(actionsArray, 'queue_interstitial')[0];
    return get(queueInterstitial, 'ads', [])
      .filter(ad => typeof ad[propertyName] !== 'undefined')
      .map(ad => ad[propertyName]);
  }

  static findActionInPayload(serverPayload, actionName, defaultValue = [{}], expected = null) {
    const actions = get(serverPayload, 'data.actions', []);
    return this.findAction(actions, actionName, defaultValue, expected);
  }

  static findAdUrlsInPayload(serverPayload) {
    const ads = this.findAdsInPayload(serverPayload);
    return ads.filter(ad => typeof ad.url !== 'undefined').map(ad => ad.url);
  }

  static findAdsInPayload(serverPayload) {
    const actions = this.findActionInPayload(serverPayload, 'queue_interstitial');
    return actions.flatMap(action => get(action, 'ads', []));
  }

  static getActionsInPayload(serverPayload) {
    return get(serverPayload, 'data.actions', []);
  }

  static getFieldsInPayload(serverPayload) {
    return get(serverPayload, 'data.fields', {});
  }

  // find a query param in the url or html of a set of ads
  // this will find and use only the first
  // instance of the query param in the ads array
  static findAttrInAdArr(array, attrString) {
    let publisherAppId = null;
    const checkForPublisherAppId = urlString => {
      const decodedStr = decodeURIComponent(urlString);
      // check attr is present
      const searchParamIndex = decodedStr.indexOf(`${attrString}=`);
      if (searchParamIndex !== -1) {
        // find the value
        const valueStartIndex = searchParamIndex + `${attrString}=`.length;
        const nextAmpersandIndex = decodedStr.indexOf('&', valueStartIndex);
        const foundAppId =
          nextAmpersandIndex !== -1
            ? decodedStr.substring(valueStartIndex, nextAmpersandIndex)
            : decodedStr.substring(valueStartIndex);

        return foundAppId;
      }
      return null;
    };

    array.forEach(obj => {
      if (obj.url) {
        const foundAppId = checkForPublisherAppId(obj.url);
        if (foundAppId) {
          publisherAppId = foundAppId;
        }
      }

      if (obj.html) {
        const foundAppId = checkForPublisherAppId(obj.html);
        if (foundAppId) {
          publisherAppId = foundAppId;
        }
      }
    });

    return publisherAppId;
  }
}

export default Payload;
